import { registerComponent } from '@gig/magic-common';
import TermsUpdatedPromptComponent from './terms-updated-prompt.vue.js';

var TermsUpdatedPrompt = registerComponent(TermsUpdatedPromptComponent);

export { TermsUpdatedPrompt };
